import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// declare ga as a function to set and sent the events

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnDestroy, OnInit {
  unSubscribeAll$ = new Subject<void>();
  constructor(public router: Router, private translate: TranslateService) {}
  ngOnDestroy(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }
  ngOnInit(): void {
    this.translate.use('en');
    this.router.events
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // gtag('set', 'page', event.urlAfterRedirects);
          // gtag('send', 'pageview');
        }
      });
  }
}
